import { setRequesterDefaultConfig, addRequestInterceptor } from '@/js/libs/api';

import { IMPERSONATED_USER_HEADER_NAME, SELECTED_COMPANY_HEADER_NAME } from 'src/contexts/AuthContext/constants.ts';

const urls = [
  '/api/ws-translate/translations-list',
  '/api/ws-translate/translations-aggregated',
  '/api/ws-translate/translation/add-missing',
  '/api/ws-translate/missing-translation',
];

// refs: #7448
// TODO migrate to runWhen parameter once released in axios
export function onTranslationListOrAddMissing(url?: string) {
  return urls.some((u) => url?.includes(u));
}

addRequestInterceptor({
  onFulfilled: async (request) => {
    if (onTranslationListOrAddMissing(request.url)) {
      request.baseURL = import.meta.env.VITE_CONSOLE_PROD_ENDPOINT;
      // Sends the translations without the selection headers: they are shared by every company and user.
      request.ignoreHeaders = [...(request.ignoreHeaders ?? []), SELECTED_COMPANY_HEADER_NAME, IMPERSONATED_USER_HEADER_NAME];
    }
    return request;
  },
});

setRequesterDefaultConfig({
  baseURL: import.meta.env.VITE_TARGET_ENDPOINT,
});
